module.exports = __webpack_public_path__ + "img/Discord-Logo-White.145dc557.svg";